import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';


interface AccessTokenState {
  token: string | null;
  expiresAt: string | null;
  requestInterceptorId: number | null;
}
interface AccessTokenAction {
  // setToken: (token: string | null) => void;
  // setExpiresIn: (expiresIn: string | null) => void;
  // setAccessToken: (accessToken: string | null) => void;
  setRequestInterceptorId: (requestInterceptorId: number | null) => void;
  setTokenInfo: (info: AccessTokenState) => void;
  reset: () => void;
}

const initialAccessTokenStoreState = (): AccessTokenState => ({
  token: null,
  expiresAt: null,
  requestInterceptorId: null,
});
export const useAccessTokenStore = create<AccessTokenState & AccessTokenAction>()(
  devtools(
    persist(
      (set) => ({
        ...initialAccessTokenStoreState(),
        setTokenInfo: (info: AccessTokenState) => set(info),
        // setToken: (token: string | null) => set({ token }),
        // setExpiresIn: (expiresIn: string | null) => set({ expiresIn }),
        // setAccessToken: (accessToken: string | null) => set({ token: accessToken }),
        setRequestInterceptorId: (requestInterceptorId: number | null) =>
          set({ requestInterceptorId }),
        reset: () => set(initialAccessTokenStoreState()),
      }),
      {
        name: 'actostrg',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);


